import { ArgumentValidator } from "./argument-validator";

export class TextareaInputResizer {

    public static checkHeight($event: InputEvent, maxHeight?: number | undefined): void {

        ArgumentValidator.notNullOrEmpty($event, 'event');

        const textarea = $event.target as HTMLTextAreaElement;

        if (!textarea) {

            return;
        }

        if (textarea.scrollHeight < textarea.offsetHeight) {

            return;
        }

        textarea.style.height = 'auto';

        if (maxHeight && textarea.scrollHeight > maxHeight) {

            textarea.style.height = `${maxHeight}px`;

            return;
        }

        textarea.style.height = `${textarea.scrollHeight}px`;
    }
}